(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ProductAPIService', productAPIService);

    function productAPIService(HttpService) {
        function generateProductGUID() {
            return HttpService.get('/Product/ProductGUID');
        }

        function getProduct(id) {
            const data = {
                productId: id,
                useListEPS: true
            };
            return HttpService.get('/Product?' + $.param(data));
        }

        function saveProduct(product) {
            var url = '/Product/SaveProduct';
            var data = {
                // New payload shape (avoids jsonString escaping):
                // { product: { ... } }
                product: product
            };
            return HttpService.post(url, data);
        }

        function getProductsWithFont(fontName) {
            var data = {
                fontName: fontName
            };
            return HttpService.get('/Product/GetProductsWithFont?' + $.param(data));
        }

        return {
            getProduct: getProduct,
            generateProductGUID: generateProductGUID,
            saveProduct: saveProduct,
            getProductsWithFont: getProductsWithFont
        };
    }
})();
